import React from "react";
import "../styles/vision.css";
export default function Vision() {
  return (
    <>
      <div className="textAlign container">
        <h1 className="containerH1">Vision</h1>
        <ul>
          <p>
            We build Optimism developer tools and solutions on tablet devices,
            phones and desktop browsers that are elegant in design and simple to
            use for our customers. We identify needs and provide solutions using
            the Optimism Stack and Web3 ecosystem.
          </p>
          <p>
            We are a home for Optimism tinkers, OP Stack developers & Web3 eco-system users focused towards developing iot solutions for Optimism Collective. 
            We are a young start-up with a simple goal to help enterprises and
            users to learn and manage their Web3 investments, resources and time
            productively, which could enable them to achieve their short term
            and long term vision and goals.
          </p>
        </ul>
      </div>
      <br />
    </>
  );
}
